import { useEffect } from 'react';
import { useLocation } from "react-router-dom";

import Aboutme from "./Aboutme";
import Footer from "./Footer";
import Skills from "./Skills";
import Contact from './Contact';

const Home = () => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) return;

        const targetId = location.hash.replace("#", "");
        const el = document.getElementById(targetId);

        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [location]);

    return (
        <div>
            <main>
                <section id="aboutme">
                    <Aboutme />
                </section>

                <section id="skills">
                    <Skills />
                </section>

                <section id="contact">
                    <Contact />
                </section>


            </main>

            <Footer />
        </div>
    );
}

export default Home;
